import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import formFieldSelectableMixin from 'next/javascripts/mixins/form-field-selectable-mixin';
import { closest } from 'next/javascripts/modules/dom';
import { DatePickerFieldResult } from '../date-picker-field';

Component('tr-date-field-result', {
  mixins: [eventListenerMixin, formFieldSelectableMixin],

  extends: [DatePickerFieldResult],

  ready() {
    this.selectedText = this.querySelector('.mdc-select__selected-text .result');
  },

  addEventListeners() {
    this.listenTo(this.resultWrapper, {
      mousedown: this.handleMousedown.bind(this),
      keydown: this.handleKeydown.bind(this),
    });
  },

  activeChanged() {
    if (this.active) {
      this.activeSelectRoot();
      this.namespacedTrigger('activeClick');
    } else {
      this.deactiveSelectRoot();
      if (document.activeElement === this.resultWrapper) this.resultWrapper.blur();
    }
  },

  selectedChanged() {
    if (!this.active) this.notchOutline(this.selected);
  },

  handleMousedown(event) {
    if (!this.active && !closest(event.target, '.link-clear')) this.active = true;
  },

  handleKeydown(event) {
    const isEscape = event.key === 'Escape' || event.keyCode === 27;
    if (isEscape) this.namespacedTrigger('escapePress');
  },

  handleClearLinkClick() {
    this.namespacedTrigger('clear');
  },
});
